

// ------------------------------------------------------------------
//                            IMPORTS
// ------------------------------------------------------------------
// Importación de la configuración necesaria.

import { V_URL_API } from '../utils/config';
/*
====================================================================
      Función verificarToken
====================================================================
Esta función verifica la validez de un token de restablecimiento de 
contraseña enviado al backend. El propósito de esta función es 
asegurarse de que el token proporcionado sigue siendo válido antes de 
continuar con el proceso de restablecimiento de contraseña.

====================================================================
*/

// ------------------------------------------------------------------
//                   DEFINICIÓN DE LA FUNCIÓN
// ------------------------------------------------------------------
/**
 * Verifica si un token de restablecimiento de contraseña es válido.
 *
 * @param {string} token - El token de restablecimiento de contraseña que se va a verificar.
 * @returns {Promise<Response>} - Una promesa que resuelve con la respuesta del servidor.
 */
export async function verificarToken(token) {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `E ${token}`);
  myHeaders.append("Content-Type", "application/json");

  const requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  return fetch(`${V_URL_API}/api/validate_token`, requestOptions);
}